export const initialise = () => {
    window.addEventListener('load', () => {
        const widget = document.querySelector('.attrax-job-alert-signup-widget')
        if (!widget) return

        const step2 = widget.querySelector<HTMLElement>('.step2')
        const alert = widget.querySelector<HTMLElement>('.alert')

        if (step2 || alert) {
            widget.scrollIntoView({behavior: 'smooth'})
        }
    })
}